import { render, staticRenderFns } from "./financeRisk.vue?vue&type=template&id=5565cd74&scoped=true"
import script from "./financeRisk.vue?vue&type=script&lang=js"
export * from "./financeRisk.vue?vue&type=script&lang=js"
import style0 from "./financeRisk.vue?vue&type=style&index=0&id=5565cd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565cd74",
  null
  
)

export default component.exports